
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.918 14.734a.909.909 0 000-1.285l-5.276-4.183a.907.907 0 00-1.285 0L6.081 13.45a.91.91 0 001.285 1.285l4.638-3.536 4.63 3.536a.916.916 0 001.284 0z"}})])
          )
        }
      }
    